import type { FaireProductEntity } from "../../entity_types/product";

export const p_kcmawvb4b9: FaireProductEntity = {
  token: "p_kcmawvb4b9",
  type: "product",
  name: "Tiger Eye Stone Vintage Red Bull Copper Heart Pendant",
  brandToken: "b_pxpb5s3cxg",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/b9c6b3d651491121f4118c3ae3a299a7032c812125d73326fb78d0c42899ffdf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d0c8f7d493ad48766ceb936a883fb7d17fbe165a501a7d58c9396015c79fe078.jpeg",
    "https://cdn.faire.com/fastly/de37e9f6cd0b37d9df98abd8fc772092bb49eb55f22e910bb20658f760695e3e.jpeg",
    "https://cdn.faire.com/fastly/f728a5159e270c088322d37006bcc50373af0e5dc04207f972c970c4381d6c3e.jpeg",
    "https://cdn.faire.com/fastly/18168f93de68e16b78c8890ee5e9804f4599bbed3e9bdd096b81ce76ca00b3bb.jpeg",
    "https://cdn.faire.com/fastly/9ffe99f27ec0f36a4c23c18120e0f4daba9393173c916a94ee35d4438065f10c.jpeg",
    "https://cdn.faire.com/fastly/a09d7c11c8a27c7e5d5db1fa6e37a891c8f363fd43c11dbc5796c09dde05d64a.jpeg",
    "https://cdn.faire.com/fastly/b715ac5801d24ae83c56d7bb53f1ffe3848a2247a80c2ea99bfed94ddf113a80.jpeg",
    "https://cdn.faire.com/fastly/790ad869a3cc269106ba93495cdb86f044df4288aa071c54d85b6e56e35817de.jpeg",
    "https://cdn.faire.com/fastly/09a608a9def2d82285ca110a1bc03b8393eb633ea652f78df3b162cccb604b1d.jpeg",
    "https://cdn.faire.com/fastly/7df88e239829b7b98611cfd46f159dd145d99ba4fd4568e7733935613e3352ba.jpeg",
  ],
  priceDollars: 9.01,
  description:
    "-ID: GEM-KS-P2496\n-Stones: Natural crystal agate\n-Weight(s): 18g\n-Size: 3.8*4.4cm\n-Length: 45+5cm\n-Quality: Excellent\n-Lead Free, Nickel Free",
  tags: [],
  msrpDollars: 18.01,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:57.970Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
